"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../../../utilities/ServiceFetch"));
var utilities_1 = require("@ikea-aoa/utilities");
var exceptions_1 = require("@ikea-aoa/exceptions");
/**
 * This class handles adding items to the One Web cart.
 *
 * GraphQL Playground: https://api.spiderpigs.se/playground.
 * GraphQL Test: https://api.spiderpigs.se/graphql.
 */
var IngkaShoppingListService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.locale Locale.
     * @param options.endpoint Endpoint.
     * @param options.clientId Client ID.
     * @param options.clientSecret Client secret.
     */
    function IngkaShoppingListService(options) {
        this.clientId = null;
        this.clientSecret = null;
        this.locale = options.locale;
        this.endpoint = options.endpoint;
        this.clientId = options.clientId;
        this.clientSecret = options.clientSecret;
    }
    /**
     * Adds items to shopping list.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.token One web token.
     * @param options.shoppingListName List name.
     * @returns Promise object.
     */
    IngkaShoppingListService.prototype.addToList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var listId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getListId({
                            token: options.token,
                            shoppingListName: options.shoppingListName
                        })];
                    case 1:
                        listId = _a.sent();
                        if (!!listId) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.createList({
                                token: options.token,
                                shoppingListName: options.shoppingListName
                            })];
                    case 2:
                        listId = _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, this.setSelectedList({ token: options.token, listId: listId })];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, this.addItemsToList({
                                items: options.items,
                                token: options.token,
                                listId: listId
                            })];
                    case 5: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns list count.
     *
     * @param options Options..
     * @param options.token One web token.
     * @param options.shoppingListName List name.
     * @returns Promise object.
     */
    IngkaShoppingListService.prototype.getListCount = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: this.getHeaders(options.token),
                            body: this.getListQuantityBody()
                        })];
                    case 1:
                        response = _a.sent();
                        data = response['data'];
                        if (!data || !Array.isArray(data.lists)) {
                            throw new exceptions_1.ServiceException('Failed to get list count. No lists in response.');
                        }
                        list = data.lists.find(function (list) { return list.name === options.shoppingListName; });
                        return [2 /*return*/, list ? list.quantity : 0];
                }
            });
        });
    };
    /**
     * Sets the shopping list which the latest item was added to as selected.
     *
     * @param options.token One web token.
     * @param options.listId List id.
     * @param options
     * @returns Promise object.
     */
    IngkaShoppingListService.prototype.setSelectedList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: this.getHeaders(options.token),
                            body: this.getSelectedListBody(options.listId)
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns list id.
     *
     * @param options Options.
     * @param options.token One web token.
     * @param options.shoppingListName List name.
     * @returns Promise object.
     */
    IngkaShoppingListService.prototype.getListId = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data, list;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: this.getHeaders(options.token),
                            body: this.getListIdBody()
                        })];
                    case 1:
                        response = _a.sent();
                        data = response['data'];
                        if (!data || !Array.isArray(data.lists)) {
                            throw new exceptions_1.ServiceException('Failed to get list id. No lists in response.');
                        }
                        list = data.lists.find(function (list) { return list.name === options.shoppingListName; });
                        return [2 /*return*/, list ? list.listId : null];
                }
            });
        });
    };
    /**
     * Creates a list and returns the ID.
     *
     * @param options Options.
     * @param options.token One web token.
     * @param options.shoppingListName List name.
     * @returns Promise object.
     */
    IngkaShoppingListService.prototype.createList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: this.getHeaders(options.token),
                            body: this.getCreateListBody(options.shoppingListName)
                        })];
                    case 1:
                        response = _a.sent();
                        data = response['data'];
                        if (!data || !data.createList || !data.createList.listId) {
                            throw new exceptions_1.ServiceException('Failed to create list. Missing "listId" in response.');
                        }
                        return [2 /*return*/, data.createList.listId];
                }
            });
        });
    };
    /**
     * Adds item to a shopping list.
     *
     * @param options Options.
     * @param options.items Array of shopping items.
     * @param options.token One web token.
     * @param options.listId List name.
     * @returns Promise object.
     */
    IngkaShoppingListService.prototype.addItemsToList = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceFetch_1.default.json(this.endpoint, {
                            credentials: 'same-origin',
                            method: 'POST',
                            headers: this.getHeaders(options.token),
                            body: this.getAddItemsBody(options.listId, options.items)
                        })];
                    case 1:
                        response = _a.sent();
                        data = response['data'];
                        return [2 /*return*/, {
                                listCount: data && data.addItems ? data.addItems.quantity : null,
                                errorList: this.getErrorList(response)
                            }];
                }
            });
        });
    };
    /**
     * Returns the body.
     *
     * @returns List ID body.
     */
    IngkaShoppingListService.prototype.getListIdBody = function () {
        return JSON.stringify({
            operationName: null,
            variables: {},
            query: '{ lists {name, listId} }'
        });
    };
    /**
     * Returns the body.
     *
     * @returns Quantity body.
     */
    IngkaShoppingListService.prototype.getListQuantityBody = function () {
        return JSON.stringify({
            operationName: null,
            variables: {},
            query: '{ lists {name, quantity} }'
        });
    };
    /**
     * Returns the body.
     *
     * @param listId List ID.
     * @param items Items.
     * @returns Mutation body.
     */
    IngkaShoppingListService.prototype.getAddItemsBody = function (listId, items) {
        var itemsString = "[" + items.map(function (item) {
            return "{ itemNo: \"" + item.id + "\", quantity: " + item.quantity + " }";
        }) + "]";
        return JSON.stringify({
            operationName: null,
            variables: {},
            query: "mutation { addItems(items: " + itemsString + ", listId: \"" + listId + "\" ) { quantity } }"
        });
    };
    /**
     * Returns the body.
     *
     * @param id Shopping list id.
     * @returns Set selected list body.
     */
    IngkaShoppingListService.prototype.getSelectedListBody = function (id) {
        return JSON.stringify({
            operationName: null,
            variables: {},
            query: "mutation { setSelected(listId: \"" + id + "\" ) { context { userId } } }"
        });
    };
    /**
     * Returns the body.
     *
     * @param name Shopping list name.
     * @returns Create list body.
     */
    IngkaShoppingListService.prototype.getCreateListBody = function (name) {
        return JSON.stringify({
            operationName: null,
            variables: {},
            query: "mutation { createList(name: \"" + name + "\") { listId } }"
        });
    };
    /**
     * Returns an error list.
     *
     * @param response Response.
     * @returns Error list.
     */
    IngkaShoppingListService.prototype.getErrorList = function (response) {
        var errors = response['errors'];
        if (errors) {
            return errors.map(function (error) {
                return {
                    code: error.extensions ? error.extensions.code : null,
                    message: error.message,
                    items: error.extensions && error.extensions.data && error.extensions.data.itemNos
                        ? error.extensions.data.itemNos
                        : null
                };
            });
        }
        return [];
    };
    /**
     * Returns headers.
     *
     * @param token Token.
     * @returns Headers.
     */
    IngkaShoppingListService.prototype.getHeaders = function (token) {
        var country = utilities_1.LocaleUtility.getCountryAndLanguage(this.locale).country;
        var headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token.value,
            Accept: 'application/json',
            'x-retail-id': country,
            'x-client-id': this.clientId,
            'x-client-secret': this.clientSecret,
            'x-is-anonymous': 'false'
            // The below can be used for accessing GraphQL Playground:
            // 'x-user-id': '2008c852-8b33-48f6-b5ef-45add754cdf5',
            // 'x-is-anonymous': true,
        };
        return headers;
    };
    return IngkaShoppingListService;
}());
exports.default = IngkaShoppingListService;
//# sourceMappingURL=IngkaShoppingListService.js.map